function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

(function ($, Drupal, debounce) {

  $(document).ready(() => {
    var tunnelStatus = $('#tunnel-status');
    var currentStatus = tunnelStatus.attr('data-id');
    var popupDismiss = tunnelStatus.find('#tunnel-popup-dismiss');
    var dismissDurationMinutes = 30;

    // Check cookies.
    var cookie = getCookie('tunnelStatus');

    // Show/Hide Popup decision.
    if (!cookie || cookie !== currentStatus) {
      tunnelStatus.removeClass('hidden');
      $(document).on('wheel touchmove', debounce(function(){
        popupDismiss.addClass('wiggle');
        setTimeout(function () {
          popupDismiss.removeClass('wiggle');
        }, 2000);
      }, 20));
      var scrollBarWidth = window.innerWidth - document.body.clientWidth;
      document.body.style.marginRight = `${scrollBarWidth}px`;
      document.body.style.overflowY = 'hidden';
    }

    // Popup close action.
    popupDismiss.on('click', function(e) {
      e.stopPropagation();
      tunnelStatus.addClass('hidden');
      document.cookie = "tunnelStatus=" + currentStatus + "; max-age=" + (60 * dismissDurationMinutes) + "; path=/;";
      document.body.style.marginRight = null;
      document.body.style.overflowY = null;
    })

    // Handle background-click.
    tunnelStatus.on('click', debounce(function() {
        popupDismiss.addClass('wiggle');
        setTimeout(function () {
          popupDismiss.removeClass('wiggle');
        }, 2000);
      }, 20));
  });

})(jQuery, Drupal, Drupal.debounce);
